<template>
  <div class="modal skin-modal offer-modal">
    <div class="overlay"  @click="$emit('closeSaleSkinModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeSaleSkinModal')" src="./../assets/close.svg"/>
      <div class="container">
        <form>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title">Sell Your Skin</div>
              <div class="form-fields-wrapper">
                <div class="input-container">
                  <div class="desc">Skin name:</div>
                  <input type="text" placeholder="Skin name" v-model="title"/>
                </div>
                <div class="input-container">
                  <div class="desc">Desired price:</div>
                  <input 
                    type="text" 
                    placeholder="Desired price"
                    v-model="price"
                    @input="handlePriceInput"
                  />
                </div>
                <div class="input-container">
                  <div class="desc">Quality:</div>
                  <select v-model="quality">
                    <option v-for="(item, i) in qualityOptions" :value="item" :key="i">{{item}}</option>
                  </select>
                </div>
                <div class="input-container">
                  <div class="desc">Steam inventory link to skin:</div>
                  <input type="text" placeholder="Steam inventory link to skin" v-model="item_url"/>
                </div>
                <div class="button" @click="create()">
                  <span>Send</span>
                </div>
                <transition name="fade">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrencyDecimals } from '../utils/useCurrency.js'

export default {
  name: 'SaleSkinModal',
  props: ['currencyCode'],
  components: {
  },
  data: function() {
    return {
      title: '',
      price: '',
      quality: '',
      item_url: '',
      debounceTimer: null,
      qualityOptions: [
        'Field-Tested',
        'Minimal Wear',
        'Battle-Scarred',
        'Well-Worn',
        'Factory New',
        'Not Painted'
      ],
    }
  },
  methods: {
    handlePriceInput(event) {
      this.price = event.target.value
      
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        const input = parseFloat(this.price) || 0
        const decimals = getCurrencyDecimals(this.currencyCode)
        this.price = input.toFixed(decimals)
      }, 400)
    },
    closeSaleSkinModal() {
      this.$emit('closeSaleSkinModal')
    },
    create() {
      let data = {
        'title': this.title,
        'price': this.price,
        'quality': this.quality,
        'item_url': this.item_url
      };
      this.$emit('createOffer', data)
    }
  }
}
</script>